export class VehicleBrochureLinks {
    constructor() {
        this.init();
    }
    init() {
        document.querySelectorAll("#vehicleLinks a")?.forEach((link) => {
            link.addEventListener("click", (e) => this.onLinkClick(e));
        });
    }
    onLinkClick(e) {
        e.preventDefault();
        const target = e.target;
        let vehicleName = target.getAttribute("id");
        const vehicleClass = target.getAttribute("href");
        const textEl = document.querySelector(vehicleClass);
        textEl.classList.add("in");
        textEl.classList.add("active");
        Array.from(textEl.parentElement.children).forEach((sibling) => {
            if (sibling !== textEl) {
                sibling.classList.remove("active");
                sibling.classList.remove("in");
            }
        });
        document
            .querySelector(`#vehicleImage img[id="${vehicleName}"]`)
            .classList.remove("hidden");
        Array.from(document.querySelectorAll(`#vehicleImage img:not([id="${vehicleName}"])`)).forEach((img) => {
            img.classList.add("hidden");
        });
        vehicleName = vehicleName.replace("_img", "");
        document.querySelector("#vehicleSelection").innerHTML = vehicleName;
        const brochureLink = document.querySelector("#brochureLink");
        brochureLink.setAttribute("href", "/resources/external/Volkswagen/Accessories/Brochures/" +
            vehicleName +
            "Brochure.pdf");
        brochureLink.classList.remove("hidden");
    }
}
window.DoUtility.SelfInstantiateOnLoad(VehicleBrochureLinks);
